import React, { useEffect } from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IzbZnsEaglesMarathon2026 = () => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: "ondemand",
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const galleryImages = [
        "DSC_1557.JPG",
        "DSC_1560.JPG",
        "DSC_1559.JPG",
        "DSC_1561.JPG",
        "DSC_1562.JPG",
        "DSC_1563.JPG",
        "DSC_1564.JPG",
        "DSC_1565.JPG",
        "DSC_1566.JPG",
        "image00001.jpeg",
        "DSC_1570.JPG",
        "DSC_1569.JPG",
        "DSC_1567.JPG",
        "image00003.jpeg",
        "image00002.jpeg",
    ];

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}
            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Commits K800,000 to the 2026 ZNS Eagles Marathon</h1>

                    <p className="pb-3">Every stride tells a story, and today, Indo Zambia Bank took a major step toward building a healthier Zambia. At a media briefing held earlier today at the ZNS Chamba Valley Garrison, Indo Zambia Bank proudly reaffirmed its commitment to community development by stepping up as corporate partners of the 2026 ZNS Eagles Marathon with a sponsorship package of K800,000. The marathon, while serving a noble cause, will also bring together people from all walks of life in unity of purpose. We firmly believe that supporting a healthcare initiative through this marathon is not only a social responsibility but also an investment in the nation's productivity and future prosperity.</p>

                    <p className="pb-3">Joined by the Guest of Honour, Minister of Green Economy and Environment Hon. Dr. Gilbert Siame MP, ZNS Commander Lieutenant General Eng. Maliti Solochi II, and Eagles Ladies Club Patron Mrs. Angela Solochi, we celebrated a shared vision: making wellness a cornerstone of national development.</p>

                    <p className="pb-3">Every entry and every kilometre covered on race day on Sunday, 6th December 2026, will directly contribute to the ongoing construction and operationalisation of the Tom Fara Hospital in Mpika District. Whether you choose the 6km Fun Run, the 10km, the 21.1km Half Marathon, or the 42.2km Full Marathon, your participation brings essential healthcare closer to communities that need it most.</p>

                    <p className="pb-3">Healthy communities are strong communities. Let us lace up for a noble cause. We look forward to seeing you at the starting line!</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #ZNSEaglesMarathon #HealthyZambia #TomFaraHospital #SupportingYouDevelopingZambia</em></b></p>

                    <h2 className="pt-5 pb-4 text-left">Gallery</h2>
                    <Slider {...settings}>
                        {galleryImages.map((name) => (
                            <div className="px-2" key={name}>
                                <img
                                    src={`https://izbassetsmain.blob.core.windows.net/izbwebassets/${name}`}
                                    style={{ width: "100%", height: "500px", objectFit: "cover" }}
                                    alt="Gallery"
                                />
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default IzbZnsEaglesMarathon2026;
